import * as React from "react";
import * as Comp from "../../common/CommonComponents";
import "../../App.css";
import * as common from "../../common/common";
import ChangePasswordModal from "./ChangePasswordModal";
import { useState, useEffect } from "react";
import { GetUserPermissionFn, moduleBinary } from "../../common/authority";
import { GetModuleList } from "../../common/authority";

import {
  Box,
  Button,
  Container,
  Menu,
  MenuItem,
  Tooltip,
  Typography,
  colors,
} from "@mui/material";

import menuItemsList from "./menuItemsList";
import MenuItems from "./menuItems";
import { Dropdown } from "react-bootstrap";
import { useCookies } from "react-cookie";

const PAGE_NAME = "NavBar.js";

const NavBar = ({ confirmLogout }) => {
  const [cookies] = useCookies();
  const [username, setUsername] = useState("");
  const [useremail, setUseremail] = useState("");
  const [userorg, setUserorg] = useState("");

  const [anchorElUser, setAnchorElUser] = React.useState(null);

  const [loading, setLoading] = useState(false);
  const [loadingText, setLoadingText] = useState("Loading...");

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };
  
  useEffect(() => {
    if (Object.keys(cookies).length !== 0 && cookies.EMAIL !== "") {
      setUsername(cookies.USER_NAME);
      setUserorg(cookies.ORG_NAME);
      setUseremail(cookies.EMAIL);
    }
  }, [cookies.EMAIL])
  
  // Change Password
  const [showChangePassword, setShowChangePassword] = useState(false);

  const [moduleCatBinary, setModuleCatBinary] = useState({
    CAT_DASHBOARD: 0b0000000000000000,
    CAT_ACCESS_MGMT: 0b0000000000000000,
    CAT_MASTER_DATA: 0b0000000000000000,
    CAT_TICKET: 0b0000000000000000,
    CAT_REPORT: 0b0000000000000000,
    CAT_SYSTEM_INFO: 0b0000000000000000,
  });

  useEffect(() => {
    if (Object.keys(cookies).length !== 0 && cookies.USER_ID.trim() !== "") {
      let promise = GetUserPermissionFn(
        cookies.USER_ID,
        "CAT_DASHBOARD",
        GetModuleList("CAT_DASHBOARD")
      );

      promise.then(
        (result) => {
          setModuleCatBinary((prevState) => ({
            ...prevState,
            CAT_DASHBOARD: result,
          }));
        },
        (error) => {
          setModuleCatBinary((prevState) => ({
            ...prevState,
            CAT_DASHBOARD: 0,
          }));
          common.c_LogWebError(PAGE_NAME, "GetUserPermissionFn", error);
        }
      );
    }
  }, [cookies]);

  useEffect(() => {
    if (Object.keys(cookies).length !== 0 && cookies.USER_ID.trim() !== "") {
      let promise = GetUserPermissionFn(
        cookies.USER_ID,
        "CAT_ACCESS_MGMT",
        GetModuleList("CAT_ACCESS_MGMT")
      );

      promise.then(
        (result) => {
          setModuleCatBinary((prevState) => ({
            ...prevState,
            CAT_ACCESS_MGMT: result,
          }));
        },
        (error) => {
          setModuleCatBinary((prevState) => ({
            ...prevState,
            CAT_ACCESS_MGMT: 0,
          }));
          common.c_LogWebError(PAGE_NAME, "GetUserPermissionFn", error);
        }
      );
    }
  }, [cookies]);

  useEffect(() => {
    if (Object.keys(cookies).length !== 0 && cookies.USER_ID.trim() !== "") {
      let promise = GetUserPermissionFn(
        cookies.USER_ID,
        "CAT_MASTER_DATA",
        GetModuleList("CAT_MASTER_DATA")
      );

      promise.then(
        (result) => {
          setModuleCatBinary((prevState) => ({
            ...prevState,
            CAT_MASTER_DATA: result,
          }));
        },
        (error) => {
          setModuleCatBinary((prevState) => ({
            ...prevState,
            CAT_MASTER_DATA: 0,
          }));
          common.c_LogWebError(PAGE_NAME, "GetUserPermissionFn", error);
        }
      );
    }
  }, [cookies]);

  useEffect(() => {
    if (Object.keys(cookies).length !== 0 && cookies.USER_ID.trim() !== "") {
      let promise = GetUserPermissionFn(
        cookies.USER_ID,
        "CAT_TICKET",
        GetModuleList("CAT_TICKET")
      );

      promise.then(
        (result) => {
          setModuleCatBinary((prevState) => ({
            ...prevState,
            CAT_TICKET: result,
          }));
        },
        (error) => {
          setModuleCatBinary((prevState) => ({
            ...prevState,
            CAT_TICKET: 0,
          }));
          common.c_LogWebError(PAGE_NAME, "GetUserPermissionFn", error);
        }
      );
    }
  }, [cookies]);

  useEffect(() => {
    if (Object.keys(cookies).length !== 0 && cookies.USER_ID.trim() !== "") {
      let promise = GetUserPermissionFn(
        cookies.USER_ID,
        "CAT_SYSTEM_INFO",
        GetModuleList("CAT_SYSTEM_INFO")
      );

      promise.then(
        (result) => {
          setModuleCatBinary((prevState) => ({
            ...prevState,
            CAT_SYSTEM_INFO: result,
          }));
        },
        (error) => {
          setModuleCatBinary((prevState) => ({
            ...prevState,
            CAT_SYSTEM_INFO: 0,
          }));
          common.c_LogWebError(PAGE_NAME, "GetUserPermissionFn", error);
        }
      );
    }
  }, [cookies]);

  useEffect(() => {
    if (Object.keys(cookies).length !== 0 && cookies.USER_ID.trim() !== "") {
      let promise = GetUserPermissionFn(
        cookies.USER_ID,
        "CAT_REPORT",
        GetModuleList("CAT_REPORT")
      );

      promise.then(
        (result) => {
          setModuleCatBinary((prevState) => ({
            ...prevState,
            CAT_REPORT: result,
          }));
        },
        (error) => {
          setModuleCatBinary((prevState) => ({
            ...prevState,
            CAT_REPORT: 0,
          }));
          common.c_LogWebError(PAGE_NAME, "GetUserPermissionFn", error);
        }
      );
    }
  }, [cookies]);

  const showHideChangePasswordModal = () => {
    setShowChangePassword(!showChangePassword);
    handleCloseUserMenu();
  };

  const onLoadingHandler = (load, text) => {
    setLoading(load);
    setLoadingText(text);
  };

  // menuItemsList.map((menu, index) => {
  //   console.log(index, menu);
  //   console.log(moduleCatBinary[menu.id])
  // })

  return (
    <Container>
      <nav style={{ display: "flex" }}>
        <ul className="menus">
          {menuItemsList.map((menu, index) => {
            return (
              moduleCatBinary[menu.id] !== 0 
              ? <MenuItems items={menu} key={index} moduleCatBinary={moduleCatBinary}/>
              : null
              // <MenuItems items={menu} key={index}/>
              // <li className="menu-items" key={index}>
              //   <a href={menu.url}>{menu.title}</a>
              // </li>
            );
          })}
        </ul>
        <Box
          sx={{
            display: "flex",
            // flexGrow: 0,
            ml: "auto",
            // justifyContent: "right",
            // overflow: "auto",
          }}
        >
          <Tooltip title="Manage account" className="menus">
            <Button
              id="account-button"
              color="inherit"
              style={{ textTransform: "capitalize", fontSize: "14px" }}
              aria-label="account of current user"
              aria-controls="user-menu"
              aria-haspopup="true"
              onClick={handleOpenUserMenu}
            >
              Welcome, {username}, {userorg}
            </Button>
          </Tooltip>
          <Menu
            id="user-menu"
            anchorEl={anchorElUser}
            open={Boolean(anchorElUser)}
            onClose={handleCloseUserMenu}
          >
            {/* <Typography fontSize={"14px"} className="user-items">
              {userorg}
            </Typography> */}
            <Typography fontSize={"14px"} className="user-items">
              {useremail}
            </Typography>
            <hr />
            <MenuItem
              className="menu-items"
              onClick={showHideChangePasswordModal}
            >
              <Typography fontSize={"14px"}>Change Password</Typography>
            </MenuItem>

            <MenuItem className="menu-items" onClick={confirmLogout}>
              <Typography fontSize={"14px"}>Logout</Typography>
            </MenuItem>
            {/* {settings.map((setting) => (
              <MenuItem key={setting} onClick={confirmLogout}>
                <Typography textAlign="center">{setting}</Typography>
              </MenuItem>
            ))} */}
          </Menu>
        </Box>{" "}
      </nav>
      {/* <Box sx={{ flexGrow: 0, ml: "auto" }}>
        <Tooltip title="Manage account" className="menus">
          <Comp.Button
            id="account-button"
            color="inherit"
            aria-label="account of current user"
            aria-controls="user-menu"
            aria-haspopup="true"
            onClick={handleOpenUserMenu}
          >
            User
          </Comp.Button>
        </Tooltip>
        <Menu
          id="user-menu"
          anchorEl={anchorElUser}
          open={Boolean(anchorElUser)}
          onClose={handleCloseUserMenu}
        >
          {settings.map((setting) => (
            <MenuItem key={setting} onClick={handleCloseUserMenu}>
              <Typography textAlign="center">{setting}</Typography>
            </MenuItem>
          ))}
        </Menu>
      </Box> */}
      <ChangePasswordModal
        showHide={showChangePassword}
        onHide={showHideChangePasswordModal}
        showHideChangePasswordModal={showHideChangePasswordModal}
        onLoading={onLoadingHandler}
      />
    </Container>
  );
};

export default NavBar;
